export default function createHelpers({ apolloClient, history }: any) {
  return {
    history,
    // fetch,
    client: apolloClient,
  };
}
